import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../scripts/api';

export default function PdiSelectPage() {
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const activeDb = sessionStorage.getItem('active_db') || '';
    if (!activeDb) {
      setMsg('Please select a database first (X-DB is required).');
      return;
    }

    const load = async () => {
      setBusy(true);
      setMsg('');
      try {
        const { data } = await api.get('/reports/ops', {
          params: { table: 'all_inventory', preset: 'in_stock_calgary', limit: 500 },
        });
        setRows(data.rows || []);
      } catch (e) {
        console.error('PDI select load failed', e.response?.data || e.message);
        const detail = e.response?.data?.error || e.response?.data?.detail || e.message;
        setMsg(`Failed to load In Stock - Calgary list: ${detail}`);
      } finally {
        setBusy(false);
      }
    };
    load();
  }, []);

  return (
    <div className="container">
      <div className="row" style={{ justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
        <h2 style={{ margin: 0 }}>Start PDI • In Stock - Calgary</h2>
        <button className="btn-outline" onClick={() => nav('/vin')}>Scan VIN</button>
      </div>

      {busy && <div className="muted">Loading…</div>}
      {msg && <div className="muted">{msg}</div>}

      <div className="card" style={{ marginTop: 12 }}>
        {rows.length === 0 && !busy && <div className="muted">No units found.</div>}
        <div className="space-y">
          {rows.map((r) => (
            <div key={r.id} className="row" style={{ justifyContent: 'space-between', gap: 8, borderBottom: '1px solid #eee', padding: '8px 0' }}>
              <div>
                <div style={{ fontWeight: 700 }}>Unit #{r.id}</div>
                <div className="muted">
                  RO/WO: {r.rowo || '—'} • Stock: {r.stock_po || '—'} • Customer: {r.customer || '—'}
                </div>
                <div className="muted">
                  Status: {r.unit_status || '—'} • Location: {r.unit_location || '—'}
                </div>
              </div>
              <div className="row" style={{ gap: 6, flexWrap: 'wrap' }}>
                <button className="btn" onClick={() => nav(`/pdi/${r.id}`)}>Start PDI</button>
                <button className="btn-outline" onClick={() => nav(`/detail/all_inventory/${r.id}`)}>View Record</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
